import { IChartContainer } from "../../models/base/chart-container.interface";
import { ChartStyleSettingsModel } from "../../models/chart-style/chart-style-settings.model";
import { IComponent } from "../component.interface";
import { TradeComponent } from "../trade.component";

export class TradeIconComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private base: IChartContainer;
    private disabled = false;

    constructor(element: HTMLElement, base: IChartContainer) {
        this.element = element
        this.base = base;
        
        this.subscribeChartData();
        this.onClick();
    }

    private subscribeChartData() {
        this.base.chartService.subscribeChartStyleData((chartStyle: ChartStyleSettingsModel) => {
            this.handleLiveData();
        });
    }

    private handleLiveData() {
        if (!this.base.isDemo) return;
        
        this.disabled = true;
        this.element.setAttribute('title', 'Change to Live Data to trade from the web');
        this.element.addClass('disabled');
        this.element.findFirst('button')?.setAttribute('disabled', 'disabled');
    }

    private onClick() {
        this.element.addEventListener('click', () => {
            if (this.disabled) return;

            const component = this.base.getComponentsByType(TradeComponent)[0] as TradeComponent;
            if (component) {
                if (component.isActive()) {
                    component.hide();
                } else {
                    component.show();
                }
            }
        });
    }
}